import { Logger } from "smart-filters";
import { WebCamSession } from "./webCamSession.js";
/**
 * Manages the runtime of WebCam input block, hooking it up to a texture, responding to changes in source,
 * and disposing of it when done.
 */
export class WebCamRuntime {
    /**
     * The device ID of the webcam to use. An empty string means default webcam.
     * Null means it hasn't been set yet.
     */
    get deviceId() {
        return this._deviceId;
    }
    /**
     * The device ID of the webcam to use. An empty string means default webcam.
     */
    set deviceId(value) {
        if (this._deviceId !== value) {
            this._deviceId = value;
            this._refresh();
        }
    }
    /**
     * Creates a new WebCamRuntime instance.
     * @param engine - The engine to use
     * @param textureOutput - The output texture
     */
    constructor(engine, textureOutput) {
        /**
         * The device ID of the webcam to use. An empty string means default webcam.
         * Null means it hasn't been set yet.
         */
        this._deviceId = null;
        this._engine = engine;
        this._textureOutput = textureOutput;
    }
    _refresh() {
        if (this._currentSession) {
            this._currentSession.dispose();
            this._currentSession = undefined;
        }
        if (this._deviceId !== null) {
            this._currentSession = new WebCamSession(this._engine, this._textureOutput, this._deviceId);
            // eslint-disable-next-line github/no-then
            this._currentSession.loadAsync().catch((e) => {
                Logger.Error(`Failed to load webcam ${e}`);
            });
        }
    }
    /**
     * Disposes the webcam runtime.
     */
    dispose() {
        if (this._currentSession) {
            this._currentSession.dispose();
            this._currentSession = undefined;
        }
    }
}
//# sourceMappingURL=webCamRuntime.js.map